@let rev = revision();
@let letsikring = rev.letsikringTilSelvstaendige;
@if (rev && letsikring) {
  <div [formGroup]="form()">
    <section formGroupName="gaeldendeRevision">
      <section formGroupName="letsikringTilSelvstaendige">
        <h3 class="mb-4">LTS</h3>

        <app-detail-row [editMode]="editMode()" label="CVR-nummer">
          {{ letsikring.cvrNr }}
          <ng-template #editor
            ><input pInputText formControlName="cvrNr"
          /></ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Firmanavn">
          {{ letsikring.firmanavn }}
          <ng-template #editor
            ><input pInputText formControlName="firmanavn"
          /></ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Selskabsform">
          {{ letsikring.firmaType }}
          <ng-template #editor>
            <p-select
              [options]="firmaTypeOptions"
              formControlName="firmaType"
              optionLabel="text"
              optionValue="value"
              appendTo="body" />
          </ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Firmarelation">
          {{ letsikring.firmaRelationsType }}
          <ng-template #editor>
            <p-select
              [options]="firmaRelationsTypeOptions"
              formControlName="firmaRelationsType"
              optionLabel="text"
              optionValue="value"
              appendTo="body" />
          </ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Arbejdsgiverbidrag">
          <td>{{ letsikring.arbejdsgiverBidrag | number: '1.2' }}</td>
          <ng-template #editor>
            <p-input-number
              formControlName="arbejdsgiverBidrag"
              locale="da"
              [maxFractionDigits]="2"
              mode="decimal" />
          </ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Medarbejderbidrag">
          <td>{{ letsikring.medarbejderBidrag | number: '1.2' }}</td>
          <ng-template #editor>
            <p-input-number
              formControlName="medarbejderBidrag"
              locale="da"
              [maxFractionDigits]="2"
              mode="decimal" />
          </ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Privatbidrag">
          <td>{{ letsikring.privatBidrag | number: '1.2' }}</td>
          <ng-template #editor>
            <p-input-number
              formControlName="privatBidrag"
              locale="da"
              [maxFractionDigits]="2"
              mode="decimal" />
          </ng-template>
        </app-detail-row>

        <app-detail-row [editMode]="editMode()" label="Tegningsmåde"
          >{{ letsikring.tegningsmaade }}
          <ng-template #editor
            ><p-select
              [options]="tegningsmaadeOptions"
              formControlName="tegningsmaade"
              optionLabel="value"
              optionValue="value"
              appendTo="body"
          /></ng-template>
        </app-detail-row>
      </section>
    </section>
  </div>

  @if (!editMode()) {
    <div class="mb-8 mt-4 ml-2">
      @if (rev.tilknyttedeLetsikringRisiko) {
        <div>
          <a class="cursor-pointer" (click)="onClickLivrente()"
            >Letsikring af indtægt (LTS)</a
          >
        </div>
        @for (t of rev.tilknyttedeLetsikringRisiko; track t) {
          <div>
            <a class="cursor-pointer" (click)="onClickTilknyttet(t)">{{
              t.produktNavn
            }}</a>
          </div>
        }
      }
    </div>
  }
}
